import QueryString from "qs";

export const getParams = (query) => {
    return QueryString.parse((query || "a?").split("?")[1]);
}